<template>
  <div class="StatusActionButtons">
    <span
      class="quick-action-buttons"
      :class="{ '-pin': showPin }"
    >
      <span
        v-for="button in quickButtons"
        :key="button.name"
        class="quick-action"
        :class="{ '-pin': showPin, '-toggle': button.dropdown?.(), '-with-extra': button.name === 'bookmark' }"
      >
        <ActionButtonContainer
          :class="{ '-pin': showPin }"
          :button="button"
          v-bind="rowProps"
        />
        <button
          v-if="showPin && currentUser"
          type="button"
          class="button-unstyled pin-action-button"
          :title="$t('general.unpin')"
          :aria-pressed="true"
          @click.stop.prevent="unpin(button)"
        >
          <FAIcon
            v-if="showPin && currentUser"
            fixed-width
            icon="thumbtack"
          />
        </button>
      </span>
      <!-- the star, the reactions and the picker, as one group of chips -->
      <span class="reaction-chips">
        <ActionButtonContainer
          v-if="chips.favorite"
          class="-chip"
          :chip="true"
          :button="chips.favorite"
          v-bind="rowProps"
        />
        <slot name="reactions" />
        <ActionButtonContainer
          v-if="chips.emoji"
          class="-chip"
          :chip="true"
          :button="chips.emoji"
          v-bind="rowProps"
        />
      </span>
      <Popover
        ref="moreActions"
        trigger="click"
        :trigger-attrs="triggerAttrs"
        class="quick-action more-actions"
        :tabindex="0"
        placement="bottom"
        :offset="{ y: 5 }"
        remove-padding
        @close="onExtraClose"
      >
        <template #trigger>
          <FAIcon
            class="action-button-inner"
            icon="ellipsis-h"
          />
        </template>
        <template #content="{close, resize}">
          <div
            :id="`popup-menu-${randomSeed}`"
            class="dropdown-menu extra-action-buttons"
            role="menu"
          >
            <div class="menu-item dropdown-item extra-action -icon">
              <button class="main-button" role="menuitem" @click.stop="() => { participantsOpen = true; close() }">
                <FAIcon icon="users" fixed-width />
                {{ $t('status.who_interacted') }}
              </button>
            </div>
            <div
              v-for="button in extraButtons"
              :key="button.name"
              class="menu-item dropdown-item extra-action -icon"
              :disabled="getClass(button).disabled"
              :class="{ disabled: getClass(button).disabled }"
            >
              <ActionButtonContainer
                :button="button"
                :status="status"
                :extra="true"
                :func-arg="funcArg"
                :get-component="getComponent"
                :outer-close="close"
                :do-action="doAction"
              />
              <button
                v-if="showPin && currentUser"
                type="button"
                class="button-unstyled pin-action-button extra-button"
                :title="$t('general.pin')"
                :aria-pressed="false"
                @click.stop.prevent="pin(button)"
              >
                <FAIcon
                  v-if="showPin && currentUser"
                  fixed-width
                  class="fa-scale-110"
                  transform="rotate-45"
                  icon="thumbtack"
                />
              </button>
            </div>
            <div
              v-if="currentUser"
              class="menu-item dropdown-item extra-action -icon"
            >
              <button
                class="main-button"
                role="menuitem"
                :tabindex="0"
                @click.stop="() => { resize(); showPin = !showPin }"
              >
                <FAIcon
                  class="fa-scale-110"
                  fixed-width
                  icon="wrench"
                /><span>{{ $t('nav.edit_pinned') }}</span>
              </button>
            </div>
          </div>
        </template>
      </Popover>
    </span>

    <UserListPopover
      v-if="participantsOpen"
      :key="selectedParticipants.name"
      full-only
      :user-ids="selectedParticipants.ids"
      :needs-load="!selectedParticipants.ids"
      :load="selectedParticipants.load"
      :has-more="selectedParticipants.hasMore"
      :load-more="selectedParticipants.loadMore"
      @close="closeParticipants"
    >
      <template #categories>
        <select v-model="participantCategory" :aria-label="$t('status.who_interacted')">
          <option v-for="category in participantCategories" :key="category.name" :value="category.name">{{ category.label }}</option>
        </select>
      </template>
    </UserListPopover>
  </div>
</template>

<script src="./status_action_buttons.js"></script>

<style lang="scss" src="./status_action_buttons.scss"></style>
